// Grid View Icon:

import React from 'react'

const GridView = () => (
  <svg width="20" viewBox="0 0 16 16">
    <path d="M0 0v4h4v-4h-4zm6 0v4h4v-4h-4zm6 0v4h4v-4h-4zm-12 6v4h4v-4h-4zm6 0v4h4v-4h-4zm6 0v4h4v-4h-4zm-12 6v4h4v-4h-4zm6 0v4h4v-4h-4zm6 0v4h4v-4h-4z" />
  </svg>
)

export default GridView
